import React from "react";
import StateIcon from "../../utils/render_test_status";
import {IconButton, Tooltip} from "@material-ui/core";
interface Props {
  stats: {
    fail: number;
    pass: number;
    pending: number;
    fail_details?: Array<{message?: string}>;
  };
}

export default function Status({stats}: Props) {
  // show icon based on the state
  const state = calculateState(stats ?? undefined);
  return (
    <Tooltip
      title={
        <div>
          Status by key:
          <table>
            <tr>
              <td>Pass</td>
              <td>{stats?.pass}</td>
            </tr>
            <tr>
              <td>Fail</td>
              <td>{stats?.fail}</td>
            </tr>
            {stats?.pending > 0 && (
              <tr>
                <td>Pending</td>
                <td>{stats.pending}</td>
              </tr>
            )}
          </table>
          {stats?.fail > 0 &&
            stats?.fail_details?.map((detail, idx) =>
              detail.message ? <div key={idx}>{detail.message}</div> : <></>,
            )}
        </div>
      }
    >
      <IconButton size="small">
        <StateIcon state={state} />
      </IconButton>
    </Tooltip>
  );
}

function calculateState(
  stats: {fail: number; pass: number; pending: number} = {
    fail: 0,
    pass: 0,
    pending: 0,
  },
) {
  return stats.fail > 0
    ? "fail"
    : stats.pending > 0
    ? "pending"
    : stats.pass > 0
    ? "pass"
    : "unknown";
}
